// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_REVIEW = "Naozaj chce\u0161 zmaza\u0165 hodnotenie?";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_REVIEW_REPLY = "Naozaj chce\u0161 zmaza\u0165 reakciu na hodnotenie?";
